<template>
  <div>
    <HistoryBaseDesign
      :pageTitle="pageTitle"
      :searchHeaderInfo="searchHeaderInfo"
      @changeInvalid="
        initPager()
        ini()
      "
      @changeProductName="
        initPager()
        ini()
      "
    >
      <template #searchDetailArea>
        <div class="px-9 py-7">
          <v-row no-gutters>
            <v-col cols="5" class="mr-9">
              <InputFormNew
                v-model="searchDetailInfo.line1"
                :detail="searchDetail.line1"
                :rowHeight="inputFormStyle.rowHeight"
                :titleCols="inputFormStyle.titleCols"
                :contentsCols="inputFormStyle.contentsCols"
              >
              </InputFormNew>
            </v-col>
            <v-col cols="6">
              <InputFormNew
                v-model="searchDetailInfo.line2"
                :detail="searchDetail.line2"
                :rowHeight="inputFormStyle.rowHeight"
                :titleCols="inputFormStyle.titleCols"
                :contentsCols="inputFormStyle.contentsCols"
              >
              </InputFormNew>
            </v-col>
          </v-row>
        </div>
      </template>
      <template #historyList>
        <HistoryList
          :summary="summary"
          :historyList="historyList"
          :headers="headers"
          :itemKey="tableKey"
          :productListHeaders="productListHeaders"
          :pagerKey="pagerKey"
          @rowDialogMethodCommon="rowDialogMethodCommon"
          @pageMove="ini"
        >
        </HistoryList>
      </template>
    </HistoryBaseDesign>

    <ShipDialog
      v-model="dialogs.ship"
      :title="$t('sale.sale_ship-operate')"
      width="80%"
      :recItems="dialogs.ship.rowItems"
      :pageInfoData="dialogs.ship.pageInfoData"
    >
      <template #historyList="{ item }">
        <HistoryList
          isOperation="ture"
          :historyList="item.historyList"
          :headers="item.headers"
          :itemKey="item.tableKey"
          :productListHeaders="item.productListHeaders"
        >
        </HistoryList>
      </template>
    </ShipDialog>

    <SalesDetailDialog
      v-model="dialogs.salesDetail"
      :title="$t('common.input_sale-details')"
      width="80%"
      :recItems="dialogs.salesDetail.rowItems"
      :pageInfoData="dialogs.salesDetail.pageInfoData"
    >
      <template #shipHistoryList="{ item }">
        <HistoryList
          isOperation="ture"
          :historyList="item.historyList"
          :headers="item.headers"
          :itemKey="item.tableKey"
          :productListHeaders="item.productListHeaders"
        >
        </HistoryList>
      </template>
    </SalesDetailDialog>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { commonUtil, customerUtil, currencyUtil } from '@/util'

import { saleStatusHistory } from '@/config'

import detail from './detail'
import headers from './headers'

import InputFormNew from '@/components/items/Designs/InputFormNew'
import { HistoryBaseDesign, HistoryList } from '@/components/layouts'

import { ShipDialog, SalesDetailDialog } from '@/components/layouts/Dialogs'
import mutationTypes from '@/store/mutationTypes'
import { i18n } from '@/main.js'

export default {
  components: {
    HistoryBaseDesign,
    HistoryList,
    InputFormNew,
    ShipDialog,
    SalesDetailDialog
  },
  data: () => {
    return {
      pageTitle: i18n.tc('common.common_stock-adjust-history'),
      pagerKey: 'storageAdjustHistory',

      // Design
      inputFormStyle: {
        rowHeight: '40px',
        titleCols: 2,
        contentsCols: 12 - 2,
        inputItemHeight: '32px'
      },

      searchDetail: detail.detail,

      headers: headers.headers,
      tableKey: headers.tableKey,
      productListHeaders: headers.productListHeaders,

      searchHeaderInfo: {
        productName: '',
        InvalidData: true,
        checkboxLabel: 'sale.sale_not-show-invalid-sales'
      },
      searchDetailInfo: {
        line1: {
          registerDate: {
            start: commonUtil.getFirstDateOneMonthAgo(),
            end: commonUtil.getLastDateThisMonth()
          },
          status: {},
          storage: {},
          adjustReason: {}
        },
        line2: {
          storageAdjustInfo: '',
          productInfo: {
            number: '',
            category: ''
          }
        }
      },

      summary: {},
      historyList: [],
      customerList: [],

      dialogs: {
        ship: {
          dialog: false,
          rowItems: {},
          pageInfoData: {}
        },
        salesDetail: {
          dialog: false,
          rowItems: {},
          pageInfoData: {}
        }
      }
    }
  },
  async created() {
    this.initPager()
    this.ini()
  },
  methods: {
    ...mapActions('Stock', ['getStockAdjustListFromApi']),
    ...mapActions('Common', ['setIsLoading']),
    ...mapGetters('Stock', ['getStockAdjustListFromState']),
    ...mapMutations('UI', [
      mutationTypes.UI_SET_PAGE,
      mutationTypes.UI_SET_PAGE_COUNT
    ]),

    async ini() {
      this.setIsLoading(true)
      customerUtil.getCustomer() // CU01_顧客一覧取得

      const getList = await this.getHistoryFromApi()
      const isNoData = !Object.keys(getList).length

      this.historyList = isNoData
        ? []
        : getList
            .sort((a, b) => {
              const keyName = 'stockAdjustId'
              if (a[keyName] > b[keyName]) return -1
              if (a[keyName] < b[keyName]) return 1
              return 0
            })
            .map((ele, Index) => {
              ele.panelIndex = Index + 1
              // ele.beforeCompleteFlgTmp = this.getBeforeCompleteFlgTmp(ele)
              return ele
            })
      this.setIsLoading(false)
    },

    formatObjectRequest(val) {
      return this.isObject(val) ? val.value : val
    },
    async getHistoryFromApi() {
      const line1 = this.searchDetailInfo.line1
      const line2 = this.searchDetailInfo.line2

      // Status
      // const paymentStatus = this.getPaymentStatusSearchValue(
      //   line2.paymentStatus
      // )
      // const shipStatus = this.getShipStatusSearchValue(line2.shipStatus)
      // const saleStatus = this.getSaleStatusSearchValue(line2.saleStatus)

      // API call
      const ret = await this.getStockAdjustListFromApi({
        invalidStockAdjustDisplay: this.searchHeaderInfo.InvalidData ? 0 : 1,

        // registerDate
        adjustStartDate: commonUtil.nullEmptyFormatNull(
          line1.registerDate.start
        ),
        adjustEndDate: commonUtil.nullEmptyFormatNull(line1.registerDate.end),
        // storage
        adjustStorageId: commonUtil.nullEmptyFormatNull(line1.storage.value),
        adjustReasonId: commonUtil.nullEmptyFormatNull(
          line1.adjustReason.value
        ),

        status: commonUtil.nullEmptyFormatNull(line1.status.value),
        // searchKey: commonUtil.nullEmptyFormatNull(line3.saleInfo.saleNumber),
        // remittanceNumber: commonUtil.nullEmptyFormatNull(
        //   line2.storageAdjustInfo
        // ),
        productNumber: commonUtil.nullEmptyFormatNull(line2.productInfo.number),
        productCategoryId: commonUtil.nullEmptyFormatNull(
          line2.productInfo.category
        ),
        productName: commonUtil.nullEmptyFormatNull(
          this.searchHeaderInfo.productName
        ),
        page: commonUtil.nullEmptyFormatNull(this.pageInfo[this.pagerKey].page)
        // page: 1
      })

      const getList = this.getStockAdjustListFromState()

      return getList
    },
    isObject(val) {
      return val && typeof val === 'object'
    },
    getPaymentStatusSearchValue(status) {
      if (!this.isObject(status)) return null
      const statusList = saleStatusHistory.PAYMENT_STATUS
      switch (status.value) {
        case statusList.BEFORE_PAYMENT: {
          return 1
        }
        case statusList.AFTER_PAYMENT: {
          return 2
        }
        default: {
          return null
        }
      }
    },
    getShipStatusSearchValue(status) {
      if (!this.isObject(status)) return null
      const statusList = saleStatusHistory.SHIP_STATUS
      switch (status.value) {
        case statusList.BEFORE_SHIP: {
          return 1
        }
        case statusList.AFTER_SHIP: {
          return 2
        }
        default: {
          return null
        }
      }
    },
    getSaleStatusSearchValue(status) {
      if (!this.isObject(status)) return null
      const statusList = saleStatusHistory.COMPLETE_STATUS
      switch (status.value) {
        case statusList.BEFORE_COMPLETE: {
          return 1
        }
        case statusList.AFTER_COMPLETE: {
          return 2
        }
        case statusList.CANCEL: {
          return 3
        }
        default: {
          return null
        }
      }
    },

    getBeforeCompleteFlgTmp(rec) {
      return rec.status == 1 && !rec.compDate
    },

    rowDialogMethodCommon(...args) {
      const [dialogName, info] = args

      switch (dialogName) {
        case 'reload': {
          this.ini()
          break
        }
        default:
          this.rowDialogMethodShip(dialogName, ...info)
      }
    },
    rowDialogMethodCommonDataSet(type, rowItems, pageInfoData) {
      const dataInfo = this.dialogs[type]
      dataInfo.rowItems = rowItems
      dataInfo.pageInfoData = pageInfoData
      dataInfo.dialog = true
    },
    rowDialogMethodShip(type, ...args) {
      const [rowItems, pageInfoData] = args
      this.rowDialogMethodCommonDataSet(type, rowItems, pageInfoData)
    },
    initPager() {
      this[mutationTypes.UI_SET_PAGE]({ index: 1, key: this.pagerKey })
      this[mutationTypes.UI_SET_PAGE_COUNT]({ length: 1, key: this.pagerKey })
    }
  },
  computed: {
    ...mapGetters('UI', ['pageInfo'])
  },
  watch: {
    searchDetailInfo: {
      deep: true,
      handler(newVal, oldVal) {
        this.initPager()
        this.ini()
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
